module.exports = __webpack_public_path__ + "scripts/jsstore.worker.fed5d06b9a733dffdb51c6960de935e9.js";